import React, { useState } from "react";
import { ReactSVG } from "react-svg";


const Slider = () => {
    const [current, setCurrent] = useState(1);

    // const history = [
    //     {
    //         id: 0,
    //         date: '2021/01',
    //         title: '建造第一礦廠',
    //         content: 'web3時代來臨，正式進軍區塊鏈世界',

    //     },
    //     {
    //         id: 1,
    //         date: '2021/03',
    //         title: '擴增礦機設備',
    //         content: '挹注領先效能與技術，大幅提升礦機效益'
    //     },
    //     {
    //         id: 2,
    //         date: '2021/07',
    //         title: '第二礦廠-100坪大型運算中心',
    //         content: '打造大型運算中心，強化風險管控安全'
    //     },
    //     {
    //         id: 3,
    //         date: '2021/08',
    //         title: '提供市場唯一算力出租商品',
    //         content: '礦場算力出租服務，佈局現在放眼未來'
    //     },
    //     {
    //         id: 4,
    //         date: '2022/03',
    //         title: '​建置 Throne of Dawn',
    //         content: '奇幻冒險史詩風格，搭配細膩唯美的視覺呈現'
    //     },
    //     {
    //         id: 5,
    //         date: '2022/08',
    //         title: '新增軟體開發部門',
    //         content: '研發新型技術及會員卡相關應用中，秉持著在堅實的技術基礎上創造實用性'
    //     },
    //     {
    //         id: 6,
    //         date: '2022/10',
    //         title: '獨創TOD去中心化平台上線',
    //         content: '​結合新時代的技術、藝術與電商生活，打造適於協作、廣泛交互傳播的平台'
    //     },
    //     {
    //         id: 7,
    //         date: '2023/04',
    //         title: 'DAPP RevXBeta 系統上線',
    //         content: 'RevX 是票券平台，帶您開啟探索新時代的入口'
    //     }
    // ]

    const review = [
        {
            id: 1,
            imgName: 'chat',
            name: '知脊整聊室',
            title: '創辦人',
            perspective: '身為「知脊整聊室」的創辦人，我想分享一下我們使用 RevX 預約平台的正面經歷。自從我們開始使用這個系統以來，我們的業務運營和客戶體驗都有了顯著的改善。在引入 RevX 之前，我們的預約管理過程相對雜亂，常常需要手動處理大量的預約請求。但是，自從使用了 RevX，一切都變得井然有序。其直觀的界面和自動化功能幫助我們輕鬆管理日常預約，從而提高整體的工作效率。',
        }
        , {
            id: 2,
            imgName: 'kumo-to-kiri',
            name: '雲霧酒吧',
            title: '經營者',
            perspective: '作為「雲霧酒吧」的經營者，我們對 RevX 預約平台的效果感到非常滿意。自從引入這一系統後，我們的場地使用效率顯著提升，接單率也有了明顯增長。以往，我們的預約管理依賴於傳統方法，經常會出現場地閒置或過度預約的情況。但自從使用了 RevX 的預約系統後，這些問題都迎刃而解。系統自動化的排程功能幫助我們高效地管理預約，確保每一個時間段都能得到最佳利用。'
        }
        , {
            id: 3,
            imgName: 'h-wine',
            name: '豪立酒窖',
            title: '經營者',
            perspective: '在當代的商業環境中，科技的整合對於提升客戶體驗和營運效率至關重要。對於專業舉辦品酒活動的豪立酒窖而言，採用RevX預約平台不僅是一次技術上的革新，更是一次品牌質感的提升。在使用RevX預約平台後，豪立酒窖的品酒活動透露出更加精緻和專業的氛圍。這個平台的流暢介面和簡便操作，使得客戶在預約過程中感受到無與倫比的便捷和尊貴。從客戶的反饋中不難看出，這種技術的融合大大增強了品牌的專業形象，從而提升了整體的品酒會質感。'
        }
        , {
            id: 4,
            imgName: 'client-1',
            name: '李婉琳',
            title: '美容沙龍老闆',
            perspective: '李婉琳使用RevX來管理她的美容沙龍預約。她特別欣賞系統如何方便地管理和追蹤每位客戶的治療歷程和偏好設置。不過，她建議增加更多針對美容服務的特定功能，如皮膚護理進度追蹤和產品使用記錄。'
        }
        , {
            id: 5,
            imgName: 'client-2',
            name: '張志偉',
            title: '個人按摩師',
            perspective: '張志偉依賴RevX來預約和管理他的按摩服務。他對系統提供的靈活時間管理和客戶偏好設定功能感到滿意。然而，他提出希望系統能夠集成一些客戶健康狀況追蹤的功能，以便於提供更個性化的按摩服務。'
        }, {
            id: 6,
            imgName: 'client-3',
            name: '趙雅雯',
            title: '美甲工作室經營者',
            perspective: '趙雅雯利用RevX來安排美甲服務的預約。她讚賞系統中的視覺化預約日曆，使得她能夠一目了然地看到每天的預約安排。但她建議增加一個功能，讓客戶能夠在預約時上傳想要的指甲設計圖片。'
        }, {
            id: 7,
            imgName: 'client-4',
            name: '黃美玲',
            title: '皮膚護理專家',
            perspective: '黃美玲使用RevX來預約皮膚護理和諮詢服務。她欣賞這個系統的客戶管理功能，尤其是能夠記錄客戶的皮膚狀況和過敏反應。不過，她希望系統能提供更多針對皮膚護理的專業建議和護理計劃模板。'
        }, {
            id: 8,
            imgName: 'client-5',
            name: '劉曉芬',
            title: '瑜珈和禪修導師',
            perspective: '劉曉芬用RevX來安排一對一瑜伽和禪修課程。她特別喜歡系統如何幫助她安排和調整課程時段，並追蹤客戶的進步。然而，她建議應該增加一個互動功能，讓客戶能在預約後提供即時反饋和建議。'
        }
    ]

    return (
        <section className="slider-container max-w-screen-xl">
            <section className="review">
                <h4>客戶評論</h4>
                <ul>
                    {
                        review.filter((item) => item.id === current).map((item) => {
                            // console.log(400 * item.id / history.length);
                            return (
                                <li key={item.id}>
                                    <div className="avatar">
                                        <img src={process.env.PUBLIC_URL + '/img/home/client-avatar/' + item.imgName + '.jpg'} alt='使用者照片' />
                                    </div>
                                    <h4>{`${item.title}, ${item.name}`}</h4>

                                    <div className="star m-3">
                                        <ReactSVG src={process.env.PUBLIC_URL + '/img/icon/star.svg'} />
                                        <ReactSVG src={process.env.PUBLIC_URL + '/img/icon/star.svg'} />
                                        <ReactSVG src={process.env.PUBLIC_URL + '/img/icon/star.svg'} />
                                        <ReactSVG src={process.env.PUBLIC_URL + '/img/icon/star.svg'} />
                                        <ReactSVG src={process.env.PUBLIC_URL + '/img/icon/star.svg'} />
                                    </div>
                                    <div className="prev-next">
                                        {item.id > 1 ? <div className="arrow-left cursor-pointer" onClick={() => setCurrent(n => n - 1)}></div> : <></>}
                                        <p className="font-normal mb-3 max-w-screen-md">{item.perspective}</p>
                                        {item.id < review.length ? <div className="arrow-right cursor-pointer" onClick={() => setCurrent(n => n + 1)}></div> : <></>}
                                    </div>

                                </li>
                            )
                        })
                    }
                </ul>

            </section>
        </section >
    )

}

export default Slider;